import { I18nService } from "@/core/services/i18nService";
import { AbstractControl, ValidationErrors, Validator } from "@angular/forms";

export class PasswordValidator implements Validator{

    constructor(protected translateService: I18nService) {
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const value = control.value
        if(!value){
            return null;
        }
        const hasUpperCase = /[A-Z]+/.test(value);

        const hasLowerCase = /[a-z]+/.test(value);

        const hasNumeric = /[0-9]+/.test(value);

        const hasSpecial = /[!-\/:-@[-`{-~]/.test(value);
            
        const isValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecial;

        return isValid ? null : {notStrongEnough: this.translateService.instant("password.validator.message") };
    }
}